import React from 'react';
import { useTranslation } from 'react-i18next';
import CollaboratorSelector, { Collaborator } from '../shared/CollaboratorSelector';
import Button from '../shared/TailwindComponents/Button';

interface TemplateCollaboratorsModalContentProps {
  collaborators: Collaborator[];
  onCollaboratorsChange: (collaborators: Collaborator[]) => void;
  onClose: () => void;
}

const TemplateCollaboratorsModalContent: React.FC<TemplateCollaboratorsModalContentProps> = ({
  collaborators,
  onCollaboratorsChange,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <div className="min-w-[500px] max-w-lg">
      <div className="p-5">
        <CollaboratorSelector
          collaborators={collaborators}
          onCollaboratorsChange={onCollaboratorsChange}
          title={t('Share with team members')}
          description={t('Add people who can access and edit this template')}
          ownerLabel={t('You are the template owner')}
          showOwnerSection={true}
        />
      </div>
      <div className="flex justify-end px-5 py-3 border-t border-gray-200 dark:border-gray-700">
        <Button variant="primary" size="small" onClick={onClose}>
          {t('Done')}
        </Button>
      </div>
    </div>
  );
};

export default TemplateCollaboratorsModalContent;
